import { FormField, instanceOfFormFieldSection, ViewModel } from '@sitecore-jss/sitecore-jss-forms';

import { EcommerceUserInfo } from '@gn-audio/jss-core';

import { FieldModelWithConditions, FieldValuesMap } from '../types/formConditions';

export type CrmFieldName = 'emailaddress1' | 'firstname' | 'lastname';

export const CRM_TO_DATA_LAYER_KEY: Record<CrmFieldName, keyof EcommerceUserInfo> = {
  emailaddress1: 'contactEmail',
  firstname: 'contactFirstName',
  lastname: 'contactLastName',
};

export const isCrmFieldName = (name: string): name is CrmFieldName => name in CRM_TO_DATA_LAYER_KEY;

export const buildUserInfoCRM = (
  fieldsArray: FormField[],
  fieldValues: FieldValuesMap
): EcommerceUserInfo => {
  const result: EcommerceUserInfo = {
    contactEmail: '',
    contactFirstName: '',
    contactLastName: '',
  };

  fieldsArray.forEach((field) => {
    if (instanceOfFormFieldSection(field)) {
      const nested = buildUserInfoCRM(field.fields, fieldValues);
      if (nested.contactEmail) result.contactEmail = nested.contactEmail;
      if (nested.contactFirstName) result.contactFirstName = nested.contactFirstName;
      if (nested.contactLastName) result.contactLastName = nested.contactLastName;
      return;
    }

    const model = field.model as ViewModel & FieldModelWithConditions;
    const crmName = model.name;
    const fieldKey = model.conditionSettings?.fieldKey;

    if (!crmName || !isCrmFieldName(crmName) || !fieldKey) return;

    const value = fieldValues[fieldKey];
    if (typeof value === 'string' && value) {
      result[CRM_TO_DATA_LAYER_KEY[crmName]] = value;
    }
  });

  return result;
};
